export default __webpack_public_path__ + "static/media/download_img.981e87ff.svg";